/* eslint-disable react/no-unused-prop-types */

import React, { FC } from 'react';
import { Space } from 'antd';
import { useHistory, useLocation } from 'react-router';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import colors from '~/constants/colors';
import { CheckmarkIcon } from '~/img';
import { useSelectStep } from '~/controllers/wizard';
import { ApplicationStep } from '~/types/ApplicationStep';

export interface ApplicationNavStepProps extends ApplicationNavStepStateProps {
  index: number;
  name: string;
  stepKey: string;
  uiKey: ApplicationStep['uiKey'];
  route: string;
  onClick?: () => void;
}

interface ApplicationNavStepStateProps {
  disabled: boolean;
  customActive: boolean;
  done: boolean;
  validationError: boolean;
  active?: boolean;
}

const ServicesNavStep: FC<any> = (props) => {
  const { index, name, route, stepKey, onClick, disabled, done, active, validationError } = props;
  const { t } = useTranslation();

  const history = useHistory();
  const location = useLocation();
  const selectStepMutation = useSelectStep();
  const handleNavClick = async () => {
    if (location.pathname === '/wizard/services') {
      return null;
    }
    if (onClick) {
      onClick();
    } else if (!disabled) {
      try {
        await selectStepMutation.mutateAsync(stepKey);
        history.push(route);
      } catch (error) {
        //
      }
    }
    return null;
  };

  return (
    <Container
      id={`ApplicationNavStep_${route}`}
      className="ApplicationNavStep"
      onClick={handleNavClick}
      disabled={disabled || location.pathname === '/wizard/services'}
      done={done}
      validationError={validationError}
      active={active ?? location.pathname === route ?? location.pathname === '/wizard/services'}
      customActive={location.pathname === '/wizard/services' && route === '/wizard/services/servicesDetails'}
    >
      <Space size={8} align="center">
        <div className="ApplicationNavStep-Index">
          {done ? <CheckmarkIcon className="ApplicationNavStep-CheckmarkIcon" /> : <span>{index}</span>}
        </div>
        <div className="ApplicationNavStep-Text">{t(name)}</div>
      </Space>
    </Container>
  );
};

const Container = styled.nav<ApplicationNavStepStateProps>`
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  display: flex;
  .ApplicationNavStep-Index {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 17px;
    aspect-ratio: 1;
    border-radius: 9px;
    border-width: 1.5px;
    border-style: solid;
    span {
      display: flex;
      font-weight: 600;
      font-size: 10px;
      line-height: 15px;
      vertical-align: middle;
    }
    .ApplicationNavStep-CheckmarkIcon {
      color: ${colors.componentBackground};
      font-size: 9px;
    }
    ${({ disabled }) =>
      disabled
        ? css`
            border-color: ${colors.disabledBlueTextColor};
            color: ${colors.disabledBlueTextColor} !important;
          `
        : css`
            border-color: ${colors.blue[1100]};
          `}
    ${({ active, customActive }) =>
      active || customActive
        ? css`
            background-color: ${colors.blue[1100]};
            color: ${colors.componentBackground};
          `
        : css`
            background-color: ${colors.componentBackground};
            color: ${colors.blue[1100]};
          `}

    ${({ done }) =>
      done
        ? css`
            background-color: ${colors.successColor};
            border-color: ${colors.successColor};
            color: ${colors.componentBackground};
          `
        : css`
            //
          `}
    ${({ validationError }) =>
      validationError
        ? css`
            background-color: ${colors.warningColor};
            border-color: ${colors.warningColor};
            color: ${colors.componentBackground};
          `
        : css`
            //
          `}
  }
  .ApplicationNavStep-Text {
    ${({ active, customActive }) =>
      active || customActive
        ? css`
            font-weight: 600;
          `
        : css``}
    ${({ disabled }) =>
      disabled
        ? css`
            color: ${colors.disabledBlueTextColor};
          `
        : css`
            //
          `}
  }
`;

export default ServicesNavStep;
